
CheckoutV2.ShipInfo = function(checkout, wrap, reviewStep) {
    var shipinfo = this;

    this.valid = false;

    this.reviewStep = reviewStep === true;

    this.$wrap = $( wrap );

    this.$inputFields = this.$wrap.find('input, select');

    this.$errorContainer = $('#shipinfo-error');

    this.fields = {
        country: $('.js-shipping_country', this.$wrap),
        taxCode: $('.js-shipping_taxCode', this.$wrap),
        firstname: $('.js-shipping_firstname', this.$wrap),
        lastname: $('.js-shipping_lastname', this.$wrap),
        company: $('.js-shipping_company', this.$wrap),
        address1: $('.js-shipping_address1', this.$wrap),
        address2: $('.js-shipping_address2', this.$wrap),
        city: $('.js-shipping_city', this.$wrap),
        state: $('.js-shipping_state', this.$wrap),
        zip: $('.js-shipping_zip', this.$wrap),
        phone: $('.js-shipping_phone', this.$wrap),
        phone_alternate: $('.js-shipping_phone_alternate', this.$wrap),
        email: $('.js-shipping_email', this.$wrap),
        address_save: $('.js-shipping_address_save', this.$wrap),
    };
	this.otherErrors = [];

    this.stateRequest = false;

    this.suggestStates = {};

    this.init = function() {
        if(!shipinfo.reviewStep) {
            shipinfo.listen();
            shipinfo.buildContent();
        }
        shipinfo.displayShippingAddress();
    };

   //Listener for the close click on the error container
    shipinfo.$errorContainer.find('button').on('click', function(e){
            e.preventDefault();
            shipinfo.hideErrors();
    });

    this.listen = function() {
        shipinfo.$inputFields.focus(function() {
            shipinfo.removeFieldError($(this));
            shipinfo.hideErrors();
        });

        shipinfo.fields.country.change(function() {
            shipinfo.getStates( checkout.session.get().shipping.state );
            shipinfo.checkMatchingZipCode();
            shipinfo.setFieldVisibility();
        });

        shipinfo.fields.zip.change(function() {
            shipinfo.checkMatchingZipCode();
        });

        shipinfo.fields.city.change( function() {
            shipinfo.checkMatchingZipCode();
        } );

        $.each( shipinfo.fields, function( fieldName, $field ) {
            $field.blur( function() {
                shipinfo.validateField( fieldName );
                // if we're changing the email on the shipinfo form, we aren't logged in, the email is present and valid,  and we're using listrak, send the cart in addition to the Identification
                if ( fieldName == 'email' && checkout && checkout.session && !checkout.session.isLoggedIn() && checkout.cart && checkout.cart.sendToListrak && $field.val() && $field.valid() )
                   window.setTimeout(function() {
                     checkout.cart.sendToListrak();
                   }, 350);
            } );
        } );
    };

    this.buildContent = function() {
        shipinfo.prefillForm();
        shipinfo.getStates( shipinfo.fields.state.val() || checkout.session.get().shipping.state );
        shipinfo.removeFieldErrors();
        shipinfo.setFieldVisibility();
    };

    this.checkMatchingZipCode = function() {
        var session = checkout.session.get();

        var quoteInfoChanged = session.shipping.zip     != shipinfo.fields.zip.val()
                            || session.shipping.country != shipinfo.fields.country.val();
		var countryChanged = session.shipping.country != shipinfo.fields.country.val() && 
								(session.shipping.country == 'US' || shipinfo.fields.country.val() == 'US');
		var usePoETA = 0+!!(shipinfo.fields.country.val() != 'US');
        if( shipinfo.fields.country.val() != "US"
            && session.shipping.city != shipinfo.fields.city.val()
            ) {
            // for international shipments, city matters sometimes (e.g. HK)
            quoteInfoChanged = true;
        }

        if( quoteInfoChanged ) {
            if ( !shipinfo.fields.country.val() ){
                shipinfo.fields.zip.val('');
                shipinfo.removeFieldError( shipinfo.fields.zip );
            } else {
                shipinfo.validateField( "zip" );
            }

            checkout.session.set( {
                shipping: {
                    zip: shipinfo.fields.zip.val(),
                    country: shipinfo.fields.country.val(),
                    city: shipinfo.fields.city.val(),
                    address1: shipinfo.fields.address1.val(),
                    address2: shipinfo.fields.address2.val(),
                },
            } );

            checkout.cart.shipping.$zip.val( shipinfo.fields.zip.val() );
            checkout.cart.shipping.removeFieldError( checkout.cart.shipping.$zip );

            checkout.cart.shipping.$country.val( shipinfo.fields.country.val() );
            checkout.cart.shipping.removeFieldError( checkout.cart.shipping.$country );

            checkout.cart.shipping.$city.val( shipinfo.fields.city.val() );
			var update_shipping = function() {
				checkout.cart.shipping.calc(false, true);
				checkout.cart.shipping.updateEstimatedShippingLink();
			};
			if (countryChanged) 
				checkout.cart.checkItems(1,1,usePoETA).then( update_shipping );
			else
				update_shipping();
        }
    };
    
    this.checkOriginalValues = function() {
        var session = checkout.session.get();

        if( session.shipping_country_original != session.shipping.country
            || session.shipping_zip_original != session.shipping.zip
        ) {
            shipinfo.fields.country.val( session.shipping_country_original );
            checkout.cart.shipping.$country.val( shipinfo.fields.country.val() );
            checkout.cart.shipping.removeFieldError( checkout.cart.shipping.$country );
            
            shipinfo.fields.zip.val( session.shipping_zip_original );
            checkout.cart.shipping.$zip.val( shipinfo.fields.zip.val() );
            checkout.cart.shipping.removeFieldError( checkout.cart.shipping.$zip );
            
            shipinfo.getStates( session.shipping_state_original );
            
            checkout.session.set( {
                shipping: {
                    zip: shipinfo.fields.zip.val(),
                    country: shipinfo.fields.country.val(),
                    state: shipinfo.fields.state.val(),
                    address1: shipinfo.fields.address1.val(),
                    address2: shipinfo.fields.address2.val(),
                },
            } );
            
            checkout.cart.shipping.calc(false, true);
            checkout.cart.shipping.updateEstimatedShippingLink();
        }
    };

    this.prefillForm = function() {

        // don't prefill form until we have the proper states loaded
        if (shipinfo.stateRequest) return;
        var session = checkout.session.get(),
            shipping = session.shipping;

        $.each( shipinfo.fields, function( fieldName, $field ) {
            // sometimes zip comes in blank, so use shipping_zip_original
            if (fieldName == 'zip') {
                if( !(shipping[fieldName] || session.shipping_zip_original) ) return;
                $field.val(shipping[fieldName] != '' ? shipping[fieldName] : session.shipping_zip_original);
            } else {
                if( ! shipping[ fieldName ]  ||  ! $field ) return;
                $field.val(shipping[fieldName]);
            }
            shipinfo.validateField( fieldName );
            if (fieldName == 'company')
                shipinfo.showCompany();
        } );

        // email not required for logged in customers
        if( session.customerID || session.email ) {
            var $email = shipinfo.fields.email;
            $email.val( session.email );
            shipinfo.validateField( "email" );
        }

        // show save address field to wholesale customers
        if( checkout.config.showSaveAddress ) {
            shipinfo.fields.address_save.parent().show();
        }

        shipinfo.checkMatchingZipCode();

        return true;
    };

    this.showCompany = function() {
        // TODO
    }

    this.getStates = function(selectState) {
        var $stateSelect = shipinfo.fields.state,
            $countryOption = shipinfo.fields.country.find('option:selected'),
            country = $countryOption.val();

        if (shipinfo.stateRequest) shipinfo.stateRequest.abort();

        $stateSelect
            .show()
            .attr('disabled', 'disabled')
            .html('<option value="">Loading States...</option>')
            .parent().show();

        if (!country) {
            $stateSelect.hide();
            return;
        }

        shipinfo.stateRequest = checkout.remote.call({
            'cache': true,
            'data': {
                'step': 'billship',
                'action': 'getStates',
                'country': country
            }
        })
            .done(function(response) {
                shipinfo.stateRequest = false;
                shipinfo.buildStates(response.data, selectState);
                shipinfo.prefillForm();
                var session = checkout.session.get();
                if (session.customerID) {
                    shipinfo.validate();
                    var stepName = checkout.currentStepName();
                    if( shipinfo.valid
                        && stepName == "shipinfo"
                        ) {
                        checkout.nextStep();
                    }
                }
            })
            .fail(function(request) {

            })
            .always( function() {
                shipinfo.stateRequest = false;
            } );
    };

    this.buildStates = function(states, selectState) {
        selectState = selectState || shipinfo.suggestStates;
        var noState = (selectState && states.length > 1) ? '' : ' selected ';

        var $stateSelect = shipinfo.fields.state,
            options = [
                '<option ' + noState + ' value="">* Select State/Province/Territory</option>'
            ];

        if (!states.length) {
            $stateSelect.html(options).parent().hide();
            return;
        }

        $.each(states, function(i, state) {
            var isSelected = state.state == selectState ? ' selected ' : '';
            options.push(
                '<option ' + isSelected + ' value="'+state.state+'">'
                    + state.name
                + '</option>'
            );
        });
        $stateSelect
            .removeAttr('disabled')
            .html(options);

/*
        if (selectState)
            $stateSelect.val(selectState);
        else
            $stateSelect[0].selectedIndex = 0;
*/
    };

    this.getFormData = function() {
        return {
            email: shipinfo.fields.email.val().trim(),
            billing: {
                email: shipinfo.fields.email.val().trim(),
            },
            shipping: {
                // for pre-filling the modal address form
                shipping_company: shipinfo.fields.company.val().trim(),
                shipping_name_first: shipinfo.fields.firstname.val().trim(),
                shipping_name_last: shipinfo.fields.lastname.val().trim(),
                shipping_address: shipinfo.fields.address1.val().trim(),
                shipping_address2: shipinfo.fields.address2.val().trim(),
                shipping_city: shipinfo.fields.city.val().trim(),
                shipping_state: shipinfo.fields.state.val(),
                shipping_country: shipinfo.fields.country.val(),
                shipping_taxCode: shipinfo.fields.taxCode.val(),
                shipping_zip: shipinfo.fields.zip.val().trim(),
                shipping_email: shipinfo.fields.email.val().trim(),
                shipping_phone: shipinfo.fields.phone.val().trim(),
                shipping_phone_alternate: shipinfo.fields.phone_alternate.val().trim(),
                shipping_address_save: shipinfo.fields.address_save.val(),
                // for everything else using this data
                company: shipinfo.fields.company.val().trim(),
                firstname: shipinfo.fields.firstname.val().trim(),
                lastname: shipinfo.fields.lastname.val().trim(),
                address1: shipinfo.fields.address1.val().trim(),
                address2: shipinfo.fields.address2.val().trim(),
                city: shipinfo.fields.city.val().trim(),
                state: shipinfo.fields.state.val(),
                country: shipinfo.fields.country.val(),
                taxCode: shipinfo.fields.taxCode.val(),
                zip: shipinfo.fields.zip.val().trim(),
                email: shipinfo.fields.email.val().trim(),
                phone: shipinfo.fields.phone.val().trim(),
                phone_alternate: shipinfo.fields.phone_alternate.val().trim(),
                address_save: shipinfo.fields.address_save.val()
            }
        };
    };

    this.setFormDataFromSession = function() {
        var session = checkout.session.get();

        if(session.email) shipinfo.fields.email.val(session.email);
        shipinfo.fields.company.val(session.shipping.company);
        shipinfo.fields.firstname.val(session.shipping.firstname);
        shipinfo.fields.lastname.val(session.shipping.lastname);
        shipinfo.fields.address1.val(session.shipping.address1);
        shipinfo.fields.address2.val(session.shipping.address2);
        shipinfo.fields.city.val(session.shipping.city);
        shipinfo.fields.country.val(session.shipping.country);
        shipinfo.fields.taxCode.val(session.shipping.taxCode);
        shipinfo.fields.zip.val(session.shipping.zip);
        shipinfo.fields.phone.val(session.shipping.phone);
        shipinfo.fields.phone_alternate.val(session.shipping.phone_alternate);
        shipinfo.fields.address_save.val(session.shipping.address_save);

        shipinfo.getStates( session.shipping.state );
    };

    this.setSessionDataFromForm = function() {
        checkout.session.set(shipinfo.getFormData());
        checkout.session.save();
    };

    this.validateFields = function( onlyField ) {
        var address = shipinfo.getFormData().shipping;

        $.each( shipinfo.fields, function( fieldName, $field ) {
            if( ! onlyField || onlyField == fieldName ) {
                shipinfo.fieldValid( $field );
            }
        } );

        shipinfo.valid = true;
        var results = window.addressValidator.validate( address );
        // allow validation failures to be triggered by other modules
        if (shipinfo.otherErrors && shipinfo.otherErrors.length >0) {
            $.each( shipinfo.otherErrors, function (idx, otherError) {
                if (shipinfo.fields[ otherError[0] ] && !results[ otherError[0] ]) {
                    results[ otherError[0] ] = otherError[1];
                    shipinfo.valid = false;
                }
            });
            shipinfo.otherErrors = [];
        }
        var minTop = Infinity;
        $.each( results, function( fieldName, errMsg ) {
            if( ! onlyField || onlyField == fieldName ) {
                var windowTop = $(window).scrollTop();
                if (shipinfo.fields[ fieldName ]) {
                    var fieldTop = shipinfo.fields[ fieldName ].parent().offset().top;
                    if (fieldTop && minTop > fieldTop) {
                        minTop = fieldTop;
                    }
                    shipinfo.fieldError( shipinfo.fields[ fieldName ], errMsg );
                    // var $field = shipinfo.fields[ fieldName ];
                    // window.scrollTo( 0, $field[0].offsetTop );
                }
            }
        });
        if (minTop != Infinity) 
            $(window).scrollTop( minTop );

        return;
    };

    this.validateField = function( fieldName ) {
        return shipinfo.validateFields( fieldName );
    };

    this.validate = function() {

        // destroy all previous errors

        shipinfo.valid = true;
        shipinfo.removeFieldErrors();
        shipinfo.hideErrors();

        checkout.session.set(shipinfo.getFormData());
        checkout.session.save();

        // start new validation
        shipinfo.validateFields();

        if( ! shipinfo.valid ) checkout.nextStep( true, 1 );

        shipinfo.checkMatchingZipCode();
        shipinfo.displayShippingAddress();

        return shipinfo.valid;
    };

    this.setFieldVisibility = function() {
        var address = shipinfo.getFormData().shipping;
        var result = window.addressValidator.getFieldDisplay( address );

        $.each( result, function( field, visibility ) {
            var $field = shipinfo.fields[ field ];
            if ( ! $field ) return;
            var $container = $field.closest( ".input-row" );
            $container.toggle( visibility );
        } );

        var isLoggedIn = checkout.session.isLoggedIn();
        if( isLoggedIn ) {
            var $email = shipinfo.fields.email;
            $email.closest( ".form-row" ).hide();
        }
    };

    this.getFeedback = function( $field ) {
        if( ! $field.length ) return $();
        var feedbackSelector = "." + $field.data( "feedback" );
        return shipinfo.$wrap.find( feedbackSelector );
    };

    this.fieldError = function($field, errorMsg) {

        shipinfo.valid = false;

        shipinfo.getFeedback( $field )
            .removeClass( "text-success" )
            .addClass( "text-danger" )
            .html( errorMsg );

    };

    this.fieldValid = function( $field ) {
        shipinfo.getFeedback( $field )
            .removeClass( "text-danger" )
            .addClass( "text-success" )
            .html( "<i class='fa fa-check'></i>" );
    };

    this.removeFieldError = function($field) {
        shipinfo.getFeedback( $field ).html( "" );
    };

    this.removeFieldErrors = function() {
        shipinfo.$inputFields.each( function( i, field ) {
            shipinfo.removeFieldError( $( field ) );
        } );
    };

    this.displayShippingAddress = function( data, poETA ) {
        var shipData = checkout.session.get().shipping;
		shipData.shipETA = checkout.cart.shipETA;
        shipData.inStorePickup = checkout.shipping.inStorePickup;
		if ( poETA )
			shipData.shipETA = checkout.cart.po_shipETA || checkout.cart.shipETA;
		
        shipData.shipping_eta = shipData.shipETA ? isoDateFormatter(shipData.shipETA) : "Unknown";

        $('.shipping-address.js-shipping-options .section-content').html(
            Jemplate.process('includes/partials/shippingInfo.html', shipData)
        );

        shipData.review = 1;
        shipData.shipping_method = checkout.shipping.shippingMethod;

        $('.js-shipping-method').html(checkout.shipping.shippingMethod); // update review shipping method

        if (shipData.shipETA && shipData.shipETA !== 'Back Ordered' && checkout.shipping.shippingETD) {
            shipData.shipping_etd = checkout.shipping.shippingETD;
        }

        $('.shipping-address.js-review.shipping-address .section-content').html(
            Jemplate.process('includes/partials/shippingInfo.html', shipData)
        );

        // Need to bind up the listeners here to step back to shipping on the review step
        // Listener to deal with the change address link that needs to send the user back to the shipping pane
        $('.js-review-change-address').on('click', function(e) {
            e.preventDefault();
            // Toggles the shipping modal show in the after step checkout callback
            checkout.showEditShipping = true;
            checkout.nextStep( false, 2 );
        });

        // Listener to deal with the change shipping method link that needs to send the user back to the shipping pane
        $('.js-review-change-shipping-method').on('click', function(e) {
            e.preventDefault();
            // Toggles the payment and review step button disabled
            checkout.nextStep( false, 2 );
        });
    };

    // Sets error message content and shows the container
    this.showErrors = function(content) { 
        shipinfo.$errorContainer.find('.msg-text').html(content);
        shipinfo.$errorContainer.show();
    };          

    // Hides the errors container, does not unset messages
    this.hideErrors = function() {
        shipinfo.$errorContainer.hide();
    }; 


    this.init();
};
